"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _layout = _interopRequireDefault(require("@/layout"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); } /**
 * 立减活动管理路由
 * 单独配置，不影响原有营销模块
 */
var instantDiscountRouter = {
  path: '/marketing/instantDiscount',
  component: _layout.default,
  redirect: '/marketing/instantDiscount/list',
  name: 'InstantDiscount',
  meta: {
    title: '立减活动管理',
    icon: 'clipboard'
  },
  children: [{
    path: 'list',
    name: 'InstantDiscountList',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/marketing/instantDiscount/index'));
      });
    },
    meta: {
      title: '立减活动列表',
      icon: ''
    }
  }
  // 路由会动态加载弹窗组件，无需在此配置
  ]
};
var _default = exports.default = instantDiscountRouter;